import { MultiTestProbableAnswerDto } from '../../../../../../model/task-model/MultiTestTaskDto'
import { Answer } from './index'

const mapAnswerToProbableAnswer = (answer: Answer): MultiTestProbableAnswerDto => ({
  itemProbablyAnswerId: answer.itemAnswerId,
})

export default mapAnswerToProbableAnswer
